<template>
  <div class="bui-entity-listing-page live-stream-editor-redesign">
    <content-with-loading-skeleton
      :isLoading="isLoading"
      loadingMessage="Loading Live Stream Data..."
      :isWithMessage="true"
    >
      <template #loaded>
        <div class="live-stream-editor-redesign__inner">
          <TopBar />

          <InfoCard>
            <template #title>
              <h2 class="info-card__title-text">Stream Binding</h2>
            </template>
            <BindingFields v-model="data.sideFeatureBindingOptions" />
          </InfoCard>

          <InfoCard>
            <template #title>
              <h2 class="info-card__title-text">Target Players Filters</h2>
            </template>
            <PlayersFilters v-model="data.filters" />
          </InfoCard>

          <!-- Sticky footer -->
          <footer class="editor-footer">
            <div class="editor-footer__inner">
              <ExitButton
                v-bind="{hasUnsavedChanges, unsetHasUnsavedChanges}"
                @exit="onExit"
                @saveAndExit="onSaveAndExit"
              />
              <SaveSubscriptionButton ref="saveSubscriptionButtonRef" />
            </div>
          </footer>
        </div>
      </template>
    </content-with-loading-skeleton>
  </div>
</template>


<script setup lang="ts">
import TopBar from './TopBar/TopBar.vue';
import { onBeforeMount, watch }  from 'vue'
import { onBeforeRouteUpdate, useRoute } from 'vue-router'
import SaveSubscriptionButton from './SaveSubscriptionButton/SaveSubscriptionButton.vue';
import ExitButton from '@/components/Dialog/ButtonsWithDialog/ExitButton/ExitButton.vue';
import InfoCard from '@/components/bui/molecules/InfoCard/InfoCard.vue';
import sharedRefs from './sharedRefs';
import router from '@/router';
import PlayersFilters from './PlayersFilters/PlayersFilters.vue';

import { useLiveStream } from './composables/liveStream';
import BindingFields from './BindingFields.vue';
const {
  data,
  loadPlayerSubscription,
  initializeHasUnsavedChangesWatcher,
  hasUnsavedChanges,
  unsetHasUnsavedChanges,
  isLoading,
} = useLiveStream();
initializeHasUnsavedChangesWatcher();

const route = useRoute()

const currentSubscriptionId = route.params.id;
const { saveSubscriptionButtonRef } = sharedRefs;

function onExit() {
  router.push({ path: '/live-streams' })
}

async function onSaveAndExit() {
  await saveSubscriptionButtonRef.value.saveLiveStream();
  router.push({ path: '/live-streams' })
}

onBeforeMount(async () => {
  await loadPlayerSubscription(Number(currentSubscriptionId));
});

onBeforeRouteUpdate(async (newRoute) => {
  if(newRoute.name === "live-stream-editor") {
    const newLiveStreamId = newRoute.params.id;
    await loadPlayerSubscription(Number(newLiveStreamId));
  }
})
</script>



<style lang="scss" scoped>
@import '@/assets/styles/bui-editor-template';

/* Outer wrapper: paints the BUI page surface edge-to-edge (see the note in
   PlayerEditorView — `.bui-entity-listing-page` is wired in PageLayout.vue). */
.live-stream-editor-redesign {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  background: var(--bui-page-fill, #ff007b);
  color: var(--bui-page-head, #fffcfd);
  padding: var(--bui-page-pad-y, 32px) var(--bui-page-pad-x, 48px) 5rem;
  box-sizing: border-box;

  @media (max-width: 1100px) {
    padding-left: 24px;
    padding-right: 24px;
  }
}

.live-stream-editor-redesign__inner {
  display: flex;
  flex-direction: column;
  gap: var(--bui-page-section-gap, 24px);
  width: 100%;
  flex: 1 1 auto;
  min-width: 0;
}
</style>
